var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3385 15.1666L18.849 11.8125H15.6042V9.62496C15.6042 8.67704 16.0417 7.80204 17.5 7.80204H18.9948V4.92183C18.9948 4.92183 17.6458 4.66663 16.3698 4.66663C13.7083 4.66663 11.9583 6.30725 11.9583 9.22392V11.8125H8.96875V15.1666H11.9583V23.3333H15.6042V15.1666H18.3385Z",
    fill: "#F7F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIconFacebook);
export default __webpack_public_path__ + "static/media/brand-icon_facebook.ba4e8e8918f05ee891947aa575e7ddbd.svg";
export { ForwardRef as ReactComponent };